export * from './work-permit.model';
